import React from "react";

function CryptoScript() {
  const scripts = [
    { title: "Binance Clone Script", desc: "Launch a crypto exchange like Binance with spot trading, futures, staking, and launchpad." },
    { title: "Coinbase Clone Script", desc: "Build a beginner-friendly exchange with simple buy/sell interface and custodial wallets." },
    { title: "WazirX Clone Script", desc: "Create an exchange with P2P trading, quick buy, and a powerful matching engine." },
    { title: "Kraken Clone Script", desc: "Develop an enterprise-grade platform with margin trading and advanced order types." },
    { title: "KuCoin Clone Script", desc: "Build a feature-rich exchange with trading bots, lending, and staking capabilities." },
    { title: "Bybit Clone Script", desc: "Launch a derivatives exchange with perpetual contracts and copy trading features." },
  ];

  return (
    <div style={{ padding: "80px 0", background: "#f7f9fc" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold" style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}>
            Crypto Exchange Script
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "650px" }}>
            Skip lengthy development timelines. Use our ready-made exchange scripts to launch your crypto trading platform in weeks.
          </p>
        </div>
        <div className="row g-4">
          {scripts.map((item, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="ce-script-card">
                <div className="ce-script-num">{String(idx + 1).padStart(2, '0')}</div>
                <h5 className="fw-bold mb-2" style={{ color: "#0a1f44", fontSize: "17px" }}>{item.title}</h5>
                <p className="mb-0 text-muted" style={{ fontSize: "14px", lineHeight: "1.6" }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CryptoScript;
